import { useState, useEffect, useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Link, Alert } from "@mui/material";
import PageTitle from "../../PageTitle/PageTitle";
import Form from "../../Form/Form";
import Input from "../../Form/Input/Input";
import DefaultButton from "../../../components/simple/DefaultButton";
import LinearProgress from "@mui/material/LinearProgress";

import { BrandContext } from "../../../App";
import { callAPI } from "../../helpers/CallAPI";

import { ResetContainer } from "./style";

// POST v1/request_password_reset - body: {email}
// POST v1/3r - body: {token,password,confirm_password}

const ResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [view, setView] = useState(0);
  const [email, setEmail] = useState(null);
  const [resetToken, setResetToken] = useState(null);
  const [message, setMessage] = useState({ type: "", msg: "" }); // error or success

  const { brand, authToken } = useContext(BrandContext);
  const [qParams] = useSearchParams();
  const navigate = useNavigate();

  const views = [
    {
      title: "Forgot Password?",
      icon: (
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.8333 10.4999C19.8333 9.9028 19.6055 9.30568 19.1499 8.85008C18.6943 8.39447 18.0972 8.16667 17.5 8.16667M17.5 17.5C21.366 17.5 24.5 14.366 24.5 10.5C24.5 6.63401 21.366 3.5 17.5 3.5C13.634 3.5 10.5 6.63401 10.5 10.5C10.5 10.8193 10.5214 11.1336 10.5628 11.4415C10.6309 11.948 10.6649 12.2013 10.642 12.3615C10.6181 12.5284 10.5877 12.6184 10.5055 12.7655C10.4265 12.9068 10.2873 13.046 10.009 13.3243L4.04673 19.2866C3.84496 19.4884 3.74407 19.5893 3.67192 19.707C3.60795 19.8114 3.56081 19.9252 3.53224 20.0442C3.5 20.1785 3.5 20.3212 3.5 20.6065V22.6333C3.5 23.2867 3.5 23.6134 3.62716 23.863C3.73901 24.0825 3.91749 24.261 4.13701 24.3728C4.38657 24.5 4.71327 24.5 5.36667 24.5H8.16667V22.1667H10.5V19.8333H12.8333L14.6757 17.991C14.954 17.7127 15.0932 17.5735 15.2345 17.4945C15.3816 17.4123 15.4716 17.3819 15.6385 17.358C15.7987 17.3351 16.052 17.3691 16.5585 17.4372C16.8664 17.4786 17.1807 17.5 17.5 17.5Z"
            stroke="#030039"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
    },
    {
      title: "Check your email",
      icon: (
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.0345 3.07261L24.8172 8.78136C25.1276 8.98308 25.2827 9.08394 25.3952 9.21848C25.4947 9.33757 25.5694 9.47532 25.6151 9.62367C25.6666 9.79125 25.6666 9.97632 25.6666 10.3465V18.9001C25.6666 20.8603 25.6666 21.8404 25.2851 22.5891C24.9496 23.2476 24.4141 23.7831 23.7556 24.1186C23.0069 24.5001 22.0268 24.5001 20.0666 24.5001H7.93325C5.97307 24.5001 4.99298 24.5001 4.24429 24.1186C3.58572 23.7831 3.05029 23.2476 2.71473 22.5891C2.33325 21.8404 2.33325 20.8603 2.33325 18.9001V10.3465C2.33325 9.97632 2.33325 9.79125 2.38478 9.62367C2.4304 9.47532 2.50516 9.33757 2.60467 9.21848C2.7171 9.08394 2.87227 8.98308 3.18261 8.78136L11.9653 3.07261M16.0345 3.07261C15.2981 2.59392 14.9299 2.35457 14.5331 2.26145C14.1824 2.17913 13.8174 2.17913 13.4667 2.26145C13.07 2.35457 12.7017 2.59392 11.9653 3.07261M16.0345 3.07261L23.2587 7.76834C24.0612 8.28996 24.4625 8.55077 24.6015 8.88152C24.7229 9.17056 24.7229 9.49632 24.6015 9.78536C24.4625 10.1161 24.0612 10.3769 23.2587 10.8985L16.0345 15.5943C15.2981 16.073 14.9299 16.3123 14.5331 16.4054C14.1824 16.4878 13.8174 16.4878 13.4667 16.4054C13.07 16.3123 12.7017 16.073 11.9653 15.5943L4.74109 10.8985C3.9386 10.3769 3.53736 10.1161 3.39839 9.78536C3.27694 9.49632 3.27694 9.17056 3.39839 8.88152C3.53736 8.55077 3.9386 8.28996 4.74109 7.76835L11.9653 3.07261M25.0833 22.1668L17.3333 15.1668M10.6665 15.1668L2.91659 22.1668"
            stroke="#030039"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
    },
    {
      title: "Set new password",
      icon: (
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.8334 11.6667V9.33333C19.8334 6.11167 17.2217 3.5 14.0001 3.5C10.7784 3.5 8.16675 6.11167 8.16675 9.33333V11.6667M14.0001 16.9167V19.25M10.2667 24.5H17.7334C19.6936 24.5 20.6737 24.5 21.4224 24.1185C22.0809 23.783 22.6164 23.2475 22.9519 22.589C23.3334 21.8403 23.3334 20.8602 23.3334 18.9V17.2667C23.3334 15.3065 23.3334 14.3264 22.9519 13.5777C22.6164 12.9191 22.0809 12.3837 21.4224 12.0481C20.6737 11.6667 19.6936 11.6667 17.7334 11.6667H10.2667C8.30656 11.6667 7.32647 11.6667 6.57778 12.0481C5.91921 12.3837 5.38378 12.9191 5.04823 13.5777C4.66675 14.3264 4.66675 15.3065 4.66675 17.2667V18.9C4.66675 20.8602 4.66675 21.8403 5.04823 22.589C5.38378 23.2475 5.91921 23.783 6.57778 24.1185C7.32647 24.5 8.30656 24.5 10.2667 24.5Z"
            stroke="#030039"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
    },
  ];

  const passwordFields = [
    {
      label: "Password",
      id: "password",
      type: "password",
      error: "Please enter a password",
    },
    {
      label: "Confirm Password",
      id: "confirm_password",
      type: "password",
      error: "Please confirm your password",
    },
  ];

  useEffect(() => {
    if (authToken) {
      navigate("/")
    }
  }, [authToken])

  useEffect(() => {
    const token = qParams.get("token");
    if (token) {
      setResetToken(token);
      setView(2);
    }
  }, [qParams]);

  useEffect(() => {
    if (view === 0) {
      document.querySelector("input").focus();
    } else if (view === 2) {
      setTimeout(() => {
        document.querySelectorAll("input")[0]?.focus();
      }, 0);
    }
  }, [view]);

  const resendEmail = async () => {
    setLoading(true);
    try {
      await callAPI(`request_password_reset`, {
        method: "POST",
        body: { email },
      });

      setMessage({ type: "success", msg: "Email resent" });
    } catch (error) {
      setMessage({
        type: "error",
        msg:
          error.detail ||
          error.message ||
          "Something went wrong. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  const viewDisplayTitle = () => {
    return <PageTitle text={views[view].title} icon={views[view].icon} />;
  };

  const clearStates = () => {
    setLoading(false);
    setMessage({ type: "", msg: "" });
  };

  const viewDisplay = () => {
    if (view === 0) {
      return (
        <>
          <p>Enter your email address below to reset your password</p>
          <Form
            action={`${brand.api_base_url}/request_password_reset`}
            method="POST"
            onBefore={() => setLoading(true)}
            onError={() => {
              setMessage({
                type: "error",
                msg: "Something went wrong. Please try again.",
              });
              setLoading(false);
            }}
            onSuccess={() => {
              setView(1);
              clearStates();
            }}
          >
            {({ register, formState: { errors } }) => (
              <>
                <Input
                  id="reset-email"
                  showLabel
                  label="Email"
                  type="email"
                  register={register("email", {
                    required: "Email address is required",
                    onChange: (e) => setEmail(e.target.value),
                  })}
                  error={errors.email?.message}
                />
                <DefaultButton type="submit">Reset Password</DefaultButton>
              </>
            )}
          </Form>
        </>
      );
    } else if (view === 1) {
      return (
        <>
          <p>
            We've sent a password reset link to {email || "email@example.com"}
          </p>
          <div className="resend">
            <p>Didn't recieve the email?</p>
            <DefaultButton onClick={() => resendEmail()}>
              Resend Email
            </DefaultButton>
          </div>
        </>
      );
    } else if (view === 2) {
      return (
        <>
          <p>Enter your new password below</p>
          {/* Destructure watch from the Form render props */}
          <Form
            action={`${brand.api_base_url}/reset_password`}
            method="POST"
            onBefore={() => setLoading(true)}
            onError={() => {
              clearStates();
              setMessage({
                type: "error",
                msg: "There was a problem, please try again.",
              });
            }}
            onSuccess={() => {
              clearStates();
              navigate("/login?after=1");
            }}
          >
            {({ register, formState: { errors }, getValues, watch }) => {
              // Watch the password field for changes
              const passwordValue = watch("password", "");

              // Define criteria with validation logic
              const criteriaList = [
                {
                  label: "Password must be at least 8 characters long",
                  valid: passwordValue.length >= 8,
                },
                {
                  label: "Password must include at least one uppercase letter",
                  valid: /[A-Z]/.test(passwordValue),
                },
                {
                  label: "Password must include at least one special character",
                  valid: /[!@#$%^&*(),.?":{}|<>]/.test(passwordValue),
                },
              ];

              return (
                <>
                  <input
                    type="hidden"
                    name="token"
                    value={resetToken}
                    {...register("token")}
                  />
                  {passwordFields.map((item) => {
                    const isConfirm = item.id === "confirm_password";
                    return (
                      <Input
                        key={item.id}
                        id={item.id}
                        showLabel
                        label={item.label}
                        type={item.type}
                        placeHolder={item.label}
                        helpText={item.helpText ? item.helpText : null}
                        register={register(item.id, {
                          required: item.error,
                          ...(isConfirm
                            ? {
                                validate: (value) => {
                                  const passVal = getValues("password");
                                  return (
                                    value === passVal ||
                                    "Passwords do not match"
                                  );
                                },
                              }
                            : {
                                minLength: {
                                  value: 8,
                                  message:
                                    "Password must be at least 8 characters long",
                                },
                                validate: {
                                  hasUppercase: (value) =>
                                    /[A-Z]/.test(value) ||
                                    "Password must include at least one uppercase letter",
                                  hasSpecialChar: (value) =>
                                    /[!@#$%^&*(),.?":{}|<>]/.test(value) ||
                                    "Password must include at least one special character",
                                },
                              }),
                        })}
                        error={errors[item.id]?.message}
                      />
                    );
                  })}

                  {/* Map through criteriaList and apply 'active' class based on valid property */}
                  <div className="password-critiera">
                    {criteriaList.map((item, index) => (
                      <div key={index}>
                        <span className={`icon ${item.valid ? "active" : ""}`}>
                          <svg
                            width="10"
                            height="7"
                            viewBox="0 0 10 7"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 3.5L3.5 6L8.5 1"
                              stroke="#211F45"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        {item.label}
                      </div>
                    ))}
                  </div>
                  <DefaultButton type="submit">Reset Password</DefaultButton>
                </>
              );
            }}
          </Form>
        </>
      );
    }
  };

  return (
    <ResetContainer>
      <div className="reset-password-container">
        {viewDisplayTitle()}
        {viewDisplay()}

        {message.type !== "" && message.msg !== "" && (
          <Alert severity={message.type} sx={{ mb: 4, mt: 4 }}>
            {message.msg}
          </Alert>
        )}
        <div className="register-helper">
          <Link className="register-link" href="/login">
            &larr; Back to login
          </Link>
        </div>
        {loading && (
          <LinearProgress
            id="reset-loading"
            color="secondary"
            sx={{ mt: 5, height: "8px", borderRadius: "6px" }}
          />
        )}
      </div>
    </ResetContainer>
  );
};

export default ResetPassword;
